import { namespacesLoader } from '@/i18n/route-namespaces'
import { CompanyLayout } from '@/layouts'

import { membersRoutes } from './members-routes'
import { projectsRoutes } from './projects-routes'
import { settingsRoutes } from './settings-routes'

export const companyRoutes = {
  path: 'companies/:companyId',
  loader: namespacesLoader(['companies', 'members']),
  element: <CompanyLayout />,
  children: [projectsRoutes, membersRoutes, settingsRoutes],
}
